export default __webpack_public_path__ + "static/media/3132 utensils side.ef34fcc1.png";